import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

export interface State {
  actionRenderingLookup: ActionRenderingLookup
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    actionRenderingLookup: {},
  }
}

/**
 * Stores {@link ents.core.mosaic.Action.Rendering} by
 * {@link ec.plugins.standard.EditingPlugin.ecModels.EntityId}
 *
 * @see {@link ActionRenderingLookup.Entry}
 */
export type ActionRenderingLookup = Partial<
  Record<ec.models.EntityId, ActionRenderingLookup.Entry>
>
export namespace ActionRenderingLookup {
  /**
   * Represents an {@link ents.core.mosaic.Action.Rendering}
   *
   * Since these are produced by an {@link ents.core.mosaic.Action.Query}, it is
   * possible that the results are not correct. So this contains both the raw
   * results and, ideally, an actual {@link ents.core.mosaic.Action.Rendering}
   */
  export interface Entry {
    rawRendering?: unknown
    rendering?: ents.core.mosaic.Action.Rendering
  }
}
